import React, { Component } from "react";

import Select from "carbon-components-react/lib/components/Select";
import SelectItem from "carbon-components-react/lib/components/SelectItem";

import axios from "axios";
import { userService } from "../../_services";
import { notifyError } from "./notification/NotificationHelper";
import { connect } from "react-redux";
import { userActions } from "../../_actions";

class CountrySelection extends Component {
  state = {
    countries: [],
    selectedCountry: localStorage.getItem("selectedCountry") || "placeholder-item",
  };

  constructor(props) {
    super(props);

    this.handleSelectionChange = this.handleSelectionChange.bind(this);
  }

  componentDidMount() {
    axios.get("/api/countries/?format=json").then(response => {
      this.setState({ countries: response.data });
    }).catch(error => {
      if (error.response.status === 401) {
        notifyError("Session expired. Please login again!")
        const { dispatch } = this.props;
        dispatch(userActions.logout());
      }
    });
  }

  handleSelectionChange(event) {
    const selectedValue = event.target.value;
    this.setState({ selectedCountry: selectedValue }); // Update state
    localStorage.setItem("selectedCountry", selectedValue); // Store in localStorage
    this.props.onSelectionChanged(selectedValue);
  }

  render() {
    const { countries, selectedCountry } = this.state;

    let countriesOption = [];

    countriesOption.push(
      <SelectItem
        key="0"
        disabled
        hidden
        value="placeholder-item"
        text="Choose country"
      />
    );

    if (this.props.addAll) {
      countriesOption.push(<SelectItem key={"all"} value={999} text={"Show All Coutries"} />);
    }
    countries.forEach(country => {
      countriesOption.push(
        <SelectItem key={country.id} value={country.id} text={country.name} />
      );
    });

    console.log("Selected:", localStorage.getItem("selectedCountry") && localStorage.getItem("selectedCountry") !== "", )

    return (
      <Select
        id="countrySelection"
        labelText={this.props.hideTitle !== undefined && this.props.hideTitle === false ? null: "Select country:"}
        value={selectedCountry}
        onChange={this.handleSelectionChange}
      >
        {countriesOption}
      </Select>
    );
  }
}

export default connect()(CountrySelection);
